export default {
  defaultPaymentMethod: "默认付款方式",
  creditCardDetails: "信用卡详细信息",
  cardInfo: "付款方式",
  RemoveCreditCard: "移除信用卡",

  // popup
  actionRequiredBeforeRemovingThisCard: "移除此卡之前需要采取的行动",
  haveUnpaidCharges: "您有正在使用的产品存在未支付的费用（{count} 信用点数）。",
  removingYourLastPaymentMethodMayPauseYourAccess:
    "移除您最后的付款方式将暂停您当前的产品（如工作流程）。请结清未付款项或添加另一张卡片以避免服务中断。",
  btnViewCharge: "查看费用",
  btnPayNow: "立即付款",
  RemoveCreditCard: "删除信用卡",

  // pending payments
  transactionDetails: "交易明细",
  accountAdmin: "帐户管理员",
  btnPayNow: "现在支付",
  paymentAmount: "金额",
  totalChargeCredit: "待支付总额",
  tabPendingPayments: "待付款",
  paySuccess: "支付成功",

  // empty table content
  noPendingPayments: "无待付款",
  anyPendingChargesWillShowUp: "任何未决费用都会在付款时显示在这里。",

  settings_billing_title: "账单与支付",
  settings_billing_desc:
    "通过清晰的付款信息掌握账单管理。从管理信用卡、查看详细发票历史到监控待处理费用，本部分帮助您保持条理清晰，确保订阅顺利运行。",
  invoice_no: "发票编号",
  transaction_date: "交易日期",
  transaction_details: "交易详情",
  transaction_amount: "金额",

  accpeted_cards: "支持的卡种",
  add_new_card: "添加新卡",
  set_as_default_payment_method: "设为默认付款方式",
  country_region: "国家/地区",
  digit3_4: "3 位 / 4 位",
  payment_security_tip: "您的支付信息通过 SSL 加密安全处理。",

  payment_add_failed_title: "添加信用卡失败",
  contact_support: "联系客服",
  try_later: "稍后再试",
  payment_add_failed_issue: "添加您的卡时出现问题。",
  payment_add_failed_unavailable: "银行服务器不可用。请稍后再试。",

  charge_remove_card: "扣费并移除卡片",
};
